/**
 * `g` then a letter jumps to a nav section (doc 05-admin/03 §8).
 *
 * One letter per section in GROUP_ORDER. Where two sections share an initial the second takes
 * another letter of its name, and the keys sheet prints the whole map, so nobody has to guess
 * that Support is `h` (help) or Platform is `l`.
 */
import { GROUP_ORDER, type AdminModule } from './modules';

export const SECTION_KEYS: Readonly<Record<string, string>> = {
  o: 'Overview',
  a: 'Analytics',
  b: 'Bookings',
  s: 'Supply',
  h: 'Support',
  p: 'People',
  c: 'Catalogue',
  m: 'Money',
  t: 'Content',
  g: 'Growth',
  l: 'Platform',
  y: 'You',
};

/** How long after `g` the letter still counts, in milliseconds. */
export const SECTION_CHORD_MS = 1500;

/**
 * The module a `g`+letter chord opens: the first one the acting scope can reach in that section,
 * in nav order. Null for an unmapped letter or a section this scope has nothing in — a jump
 * never lands on a screen the nav would not have shown.
 */
export function sectionTarget(letter: string, reachable: readonly AdminModule[]): AdminModule | null {
  const group = SECTION_KEYS[letter.toLowerCase()];
  if (!group) return null;
  return reachable.find((m) => m.group === group) ?? null;
}

/** The sheet's rows, in nav order: "Bookings — g b". */
export const SECTION_ROWS: readonly (readonly [string, string])[] = GROUP_ORDER.map((group) => {
  const letter = Object.keys(SECTION_KEYS).find((k) => SECTION_KEYS[k] === group);
  return [`Go to ${group}`, `g ${letter}`] as const;
});
